export const normalizeSmsPhone = value => {
  const digits = String(value || '').replace(/\D/g, '');
  const local =
    digits.startsWith('55') && digits.length === 13 ? digits.slice(2) : digits;
  return local.length === 11 &&
    Number(local.slice(0, 2)) >= 11 &&
    local[2] === '9'
    ? local
    : null;
};

export const analyzeSmsRecipients = values => {
  const filled = values.map(value => value.trim()).filter(Boolean);
  const normalized = filled.map(normalizeSmsPhone);
  const valid = normalized.filter(Boolean);
  const unique = [...new Set(valid)];

  return {
    total: filled.length,
    valid: unique,
    invalid: normalized.filter(value => !value).length,
    duplicates: valid.length - unique.length,
  };
};

const parseCsvLine = (line, separator) => {
  const cells = [];
  let value = '';
  let quoted = false;

  Array.from(line).forEach((character, index) => {
    if (character === '"' && line[index + 1] === '"' && quoted) {
      value += '"';
    } else if (character === '"' && line[index - 1] !== '"') {
      quoted = !quoted;
    } else if (character === separator && !quoted) {
      cells.push(value.trim());
      value = '';
    } else if (!(character === '"' && line[index - 1] === '"')) {
      value += character;
    }
  });
  cells.push(value.trim());
  return cells;
};

export const phonesFromSmsCsv = content => {
  const lines = content
    .replace(/^\uFEFF/, '')
    .split(/\r?\n/)
    .filter(line => line.trim());
  if (!lines.length) return [];

  const separator = lines[0].includes(';') ? ';' : ',';
  const rows = lines.map(line => parseCsvLine(line, separator));
  const headerIndex = rows[0].findIndex(cell =>
    /^(telefone|telefone celular|celular|phone|numero|número)$/i.test(
      cell.trim()
    )
  );
  const column = headerIndex >= 0 ? headerIndex : 0;
  return rows
    .slice(headerIndex >= 0 ? 1 : 0)
    .map(row => row[column] || '')
    .filter(Boolean);
};
